import React from "react";
import { BtnPrimary } from "../../share/buttons/Btn";
import DashCard from "../../share/cards/DashCard";
import DashCrousel from "../../../Assets/Image/png/dashCrousel.png";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                display: "block",
                background: "rgba(156, 95, 164, 0.21) ",
                borderRadius: "50%",
                padding: "2rem",
                marginRight: "-2rem",
                zIndex: 0,
            }}
            onClick={onClick}
        >
            <p className="z-10 text-black font-bold block w-10 h-10 font-thin">
                &rsaquo;
            </p>
        </div>
    );
}

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                display: "block",
                background: "rgba(156, 95, 164, 0.21)",
                borderRadius: "50%",
                padding: "2rem",
                marginRight: "-2rem",
                zIndex: 0,
            }}
            onClick={onClick}
        >
            <p className="z-10 text-black font-bold block w-10 h-10 font-thin">
                &lsaquo;
            </p>
        </div>
    );
}

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
};
function StudentDashboardCrousel({ courses, className }) {
    let navigate = useNavigate();

    const handleClick = (title) => {
        navigate("/coursedash/generalinfo", {
            state: {
                title: title,
            },
        });
    };
    return (
        <div>
            <Slider {...settings}>
                {courses?.map((course) => {
                    return (
                        <DashCard
                            className="flex py-10 px-12 justify-between flex-row-reverse"
                            topRight
                        >
                            <div className="">
                                <h4 className=" text-purple-dark font-bold text-sm mb-8">
                                    {course.bootcamp_name}
                                </h4>
                                <div className=" mb-8 text-[1.8rem] flex items-center flex-row-reverse">
                                    <span className="text-gray">:استاد</span>
                                    <h6 className="inline">
                                        {course.bootcamp_organizer}
                                    </h6>
                                </div>
                                <div className=" mb-8 text-[1.8rem] flex items-center flex-row-reverse">
                                    <span className="text-gray">
                                        :دسته بندی
                                    </span>
                                    <h6 className="inline">
                                        {course.bootcamp_category}
                                    </h6>
                                </div>
                                <div className=" mb-8 text-[1.8rem] flex items-center flex-row-reverse">
                                    {/* <span className="text-gray ml-3">
                                        :میزان تکمیل دوره
                                    </span>
                                    <h6 className="inline ml-4">
                                        %{course?.progress}
                                    </h6>
                                    <progress
                                        className="progress w-[14.8rem] h-4 progress-primary "
                                        style={{ direction: "rtl" }}
                                        value={course?.progress}
                                        max="100"
                                    /> */}
                                </div>
                                <BtnPrimary
                                    text="داشبورد دوره"
                                    className="px-4 py-7"
                                    onClick={() => handleClick(course.title)}
                                />
                            </div>
                            <div className="crousel">
                                <img
                                    src={course.bootcamp_cover}
                                    className="inline crousel__Image h-full w-full"
                                    alt={DashCrousel}
                                />
                            </div>
                        </DashCard>
                    );
                })}
            </Slider>
        </div>
    );
}

export default StudentDashboardCrousel;
